<ion-header class="mobile-header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        (click)="closeDialog()"
        class="darkModeText"
        text=""
        ios="chevron-back-outline"
        md="arrow-back-outline"
      >
      </ion-back-button>
    </ion-buttons>
    <h4 class="heading">{{ "Details Confirmation" | translate }}</h4>
  </ion-toolbar>
</ion-header>
<ion-grid [formGroup]="hpvForm" class="dailog">
  <ion-row>
    <ion-col size-md="12" class="due ion-no-padding desktop-header">
      <h1 class="pageTitle">
        {{ "Details Confirmation" | translate }}
        <ion-icon (click)="closeDialog()" class="custom-close"></ion-icon>
      </h1>
    </ion-col>
  </ion-row>
  <ion-label class="required">{{ "Mobile Number" | translate }}</ion-label>
  <ion-item class="item-border ion-no-padding" lines="none">
    <ion-input
      formControlName="mobile_number"
      errorText=" "
      placeholder="+91"
      appIntegerInput
      [appRange]="[1000000000, 9999999999]"
      [appMin]="1000000000"
      inputmode="numeric"
      pattern="[0-9]*"
      [type]="'tel'"
      maxlength="10"
      appMobileNumber="true"
      [appMax]="9999999999"
    >
    </ion-input>
  </ion-item>

  <app-hpv-past-vaccinations
    *ngIf="sessionData?.uip_session_category_id == 4"
    [parentForm]="hpvForm"
    [sessionDetails]="sessionData"
    [benDetails]="benfDetails"
  >
  </app-hpv-past-vaccinations>
  <app-vaccine-consent
    *ngIf="sessionData?.uip_session_category_id == 4"
    [parentForm]="hpvForm"
  ></app-vaccine-consent>
</ion-grid>
<ion-footer
  ><ion-row>
    <ion-col size-md="12" class="ion-text-end">
      <ion-button
        (click)="closeDialog()"
        type="button"
        class="cancelBtn"
        fill="outline"
      >
        {{ "Cancel" | translate }}
      </ion-button>
      <ion-button
        [disabled]="isLoading"
        (click)="onSubmit()"
        type="button"
        class="primaryBtn"
        shape="round"
        color="primary"
      >
        <ion-spinner *ngIf="isLoading" name="lines-small"></ion-spinner>
        {{ "Continue" | translate }}
      </ion-button>
    </ion-col>
  </ion-row></ion-footer
>
